mutation createUsDisbursement($caseRecordId: ID!) {
  createUsDisbursement(input: { caseRecordId: $caseRecordId }) {
    success
  }
}
